




























































































import Vue from "vue";
import BaseAlert from "../../components/black_dashboard_pro/BaseAlert.vue";
import HttpClientFactory from "../../services/HttpClientFactory";
import HttpClient from "../../services/HttpClient";

export default Vue.extend({
  components: {
    BaseAlert,
  },
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
  },
  data() {
    return {
      sent: false,
      isLoading: false,
      httpClient: {} as HttpClient,
      form: {
        subject: "",
        message: "",
      },
    };
  },
  methods: {
    sendContactMessage() {
      this.isLoading = true;
      this.httpClient = HttpClientFactory.getInstance();
      this.httpClient
        .post(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/private-contact",
          this.form
        )
        .then(() => {
          this.isLoading = false;
          this.sent = true;
          setTimeout(() => {
            this.sent = false;
          }, 3000);
        })
        .catch((e: any) => {
          this.isLoading = false;
          const error: any = {
            text: this.$t("contact:error"),
            type: "error",
          };
          this.$notify(error);
        });
    },
  },
});
